

const initialState = {
    brExceptions: [],
}

export default initialState